var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-size-75 text--muted"},[_c('span',[_vm._v("© "+_vm._s(_vm.coyrightYear))]),(_vm.$vuetify.breakpoint.mdAndUp)?_c('span',[_vm._v(" "+_vm._s(_vm.$env.VUE_APP_COPYRIGHT_HOLDER)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }